import { useQuery } from "react-query";
import axios from "axios";
import { BessSocRacksResponse } from "./BessBmsSocTypes";

// Endpoint do main-api. O powerStation é resolvido no backend a partir do equipmentId;
// o header Email/Bearer é injetado automaticamente pelo AxiosInterceptor.
const bmsSocUrl = (equipmentId: number) => `api/teleobject/bess-soc-racks/${equipmentId}`;

const fetchBmsSoc = async (equipmentId: number): Promise<BessSocRacksResponse> => {
    return await axios
        .get<BessSocRacksResponse>(bmsSocUrl(equipmentId), { timeout: 30000 })
        .then((res) => res.data);
};

export const useBessBmsSoc = (equipmentId: number) => {
    return useQuery({
        queryKey: ["bess-bms-soc", equipmentId],
        queryFn: () => fetchBmsSoc(equipmentId),
        enabled: Boolean(equipmentId),
    });
};
